import axios from 'axios';
class OilFinderApiService {
    constructor(baseURL) {
        this.api = axios.create({
            baseURL,
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 10000,
        });
        // Request interceptor
        this.api.interceptors.request.use((config) => {
            return config;
        }, (error) => Promise.reject(error));
        // Response interceptor
        this.api.interceptors.response.use((response) => response, (error) => {
            // Handle errors globally
            console.error('API Error:', error);
            return Promise.reject(error);
        });
    }
    // Vehicle related endpoints
    async getVehicleCategories() {
        const response = await this.api.get('/vehicle/categories');
        return response.data.data;
    }
    async getVehicleMakes(categoryId) {
        const response = await this.api.get('/vehicle/makes?categoryId=' + categoryId);
        return response.data.data;
    }
    async getVehicleModels(makeId) {
        const response = await this.api.get('/vehicle/models?makeId=' + makeId);
        return response.data.data;
    }
    async getVehicleTypesByLicencePlate(language, licencePlate) {
        const response = await this.api.get('/vehicle/licence-plate?language=' + language + '&licencePlate=' + licencePlate);
        return response.data;
    }
    async getVehicleTypesByModelId(modelId) {
        const response = await this.api.get('/vehicle/types?modelId=' + modelId);
        return response.data;
    }
    async getProductRecommendations(typeId) {
        const response = await this.api.get('/recommendations?typeId=' + typeId);
        return response.data;
    }
    async getSharedRecommendations(shareCode) {
        const response = await this.api.get('/shared-recommendation?shareCode=' + shareCode);
        return response.data;
    }
    // Generic request method for custom endpoints
    async request(method, url, data, config) {
        const response = await this.api.request({
            method,
            url,
            data,
            ...config
        });
        return response.data;
    }
}
let apiServiceInstance = null;
export function createOilFinderApi(baseURL) {
    if (!apiServiceInstance) {
        apiServiceInstance = new OilFinderApiService(baseURL);
    }
    return apiServiceInstance;
}
export function useOilFinderApi() {
    if (!apiServiceInstance) {
        throw new Error('OilFinderApiService not initialised. Call createOilFinderApi first.');
    }
    return apiServiceInstance;
}
